import app from '@/app';

/* @ngInject */
function Sat($resource) {
	return $resource(
		'api/sats/:id',
		{ id: '@id' },
		{
			query: { method: 'GET' },
			purge: { method: 'DELETE' }
		}
	);
}

app.factory('Sat', Sat);
